import {nothingSelector} from 'services/utils/selectors/nothingSelector';
import {useAppSelector} from 'store/hooks';
import {selectMetadataEditMetadataManifestationById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';
import type {ManifestationV4} from '../types';

export const useConditionalManifestationEdit = (
  manifestationId: string,
  required: boolean,
): ManifestationV4 | undefined => {
  const selector = useCreateSelectorById(
    manifestationId,
    selectMetadataEditMetadataManifestationById,
  );
  return useAppSelector(required ? selector : nothingSelector);
};
